import { SwitchCase } from '@vision/ui/components';
import { ReportChartMeasureType } from '@vision/ui/interfaces';
import { ReportsDetailGraphicFeedbackBasedQuestionBased } from '../../../ReportsDetailGraphicMeasureComponents';

interface FeedbackBasedQuestionBasedMeasureRendererProps {
  measure: ReportChartMeasureType;
}
export function FeedbackBasedQuestionBasedMeasureRenderer({ measure }: FeedbackBasedQuestionBasedMeasureRendererProps) {
  return (
    <SwitchCase
      value={measure}
      caseBy={{
        'feedback-nps': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
        'feedback-csat': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
        'feedback-ces': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
        'feedback-weighted-score': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
        'feedback-sentiment-score': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
      }}
    />
  );
}
